import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContactUsComponent } from './contact-us/contact-us.component'
import { ThankYouComponent } from './../thank-you/thank-you.component'
const routes: Routes = [
  { path: 'applications/ContactUs', component: ContactUsComponent, data: { title: '' } },
  { path: 'thankYou', component: ThankYouComponent, data: { title: '' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContactUsRoutingModule { }
